import { render, staticRenderFns } from "./ApprovalListModal.vue?vue&type=template&id=145f1ca6"
import script from "./ApprovalListModal.vue?vue&type=script&lang=ts"
export * from "./ApprovalListModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports